import {yupResolver} from '@hookform/resolvers/yup';
import Fuse from 'fuse.js';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {FormProvider, SubmitHandler, useForm} from 'react-hook-form';
import {
  FlatList,
  SafeAreaView,
  Text,
  TextInput as TextInput1,
  TouchableOpacity,
  View,
} from 'react-native';
import Icon from '@react-native-vector-icons/fontawesome';
import {useSelector} from 'react-redux';
import * as yup from 'yup';
import {ShowToast} from '../Common/common';
import BTButton from '../Components/BTButton';
import BTComboBox from '../Components/BTComboBox';
import {Col, Row} from '../Components/BTGrid';
import {TextInput} from '../Components/BTTextInput';
import {
  useInsertPurchaseorderMutation,
  useUpdatePurchaseorderMutation,
} from '../redux/services/stepurchaseorderApi';
import {useGetSTMGroupsQuery} from '../redux/services/stmgroupApi';
import {useGetSTMProductsQuery} from '../redux/services/stmproductApi';
import {useGetSuppliersQuery} from '../redux/services/stmsupplierApi';
import {RootState} from '../redux/store';
import styles from '../styles/Styles';

import T from '../Components/T';
import { tp } from '../utils/translateText';
interface item {
  pr_group?: number;
  pr_id: number;
  pr_name?: string;
  pr_srate: number;
  pr_qty: number;
  pr_nameed: boolean;
  value: po_mproduct;
}

interface Quantities {
  [key: string]: {
    descr: string;
    quantity: number;
    rate: number;
    remarks: string;
    nameed: boolean;
  };
}

const validationSchema = yup.object().shape({
  po_supp: yup
    .number()
    .required()
    .typeError('Select Supplier?')
    .min(1, 'Select Supplier'),
});

const STPurchaseOrder = ({navigation, route}: UniversalProps) => {
  const gdata: any = useSelector((state: RootState) => state.gdata);
  const [search, setSearch] = useState('');
  const [group, setGroup] = useState(0);
  const [cart, setCart] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [quantities, setQuantities] = useState<Quantities>({});
  const [showHead, setShowHead] = useState(true);

  const cid = gdata.company;

  const {data: suppData} = useGetSuppliersQuery(cid);
  const {data, refetch} = useGetSTMProductsQuery(gdata.company);

  useEffect(() => {
    refetch();
  }, []);

  const {data: groupData} = useGetSTMGroupsQuery(gdata.company);

  const supps = suppData?.map(value => ({
    label: value.sp_name,
    id: value.sp_id,
    values: value,
  }));

  const groups = groupData?.map(value => ({
    label: value.gr_name,
    id: value.gr_id,
    values: value,
  }));

  const products1 = data?.map(value => ({
    pr_group: value.pr_group,
    pr_id: value.pr_id,
    pr_name: value.pr_name,
    pr_srate: value.pr_srate,
    pr_qty: 0,
    pr_grname: value.pr_grname,
    pr_nameed: value.pr_name === '',
    value,
  }));

  const renderSeparator = () => <View style={styles.separator} />;

  const handleCart = (item: item, qty: number) => {
    const rate =
      Number(item.pr_srate) > 0
        ? Number(item.pr_srate)
        : Number(quantities[item.pr_id]?.rate) || 0;

    // Don't add if rate is 0 and user hasn't entered one yet (only when
    // adding quantity, not removing) - otherwise an undefined/NaN rate
    // silently reaches pd_rate in the submitted purchase order.
    if (rate <= 0 && qty > 0 && Number(item.pr_srate) === 0) {
      ShowToast('Please enter rate first', 'error');
      return;
    }

    if ((quantities[item.pr_id]?.quantity || 0) + qty >= 0) {
      setQuantities({
        ...quantities,
        [item.pr_id]: {
          descr: item.pr_name,
          quantity: (Number(quantities[item.pr_id]?.quantity) || 0) + qty,
          rate,
          nameed: item.pr_nameed,
        },
      });
    } else {
      const newQuantities = {...quantities};
      delete newQuantities[item.pr_id];
      setQuantities(newQuantities);
    }
  };

  const handleCartClick = () => {
    setCart(!cart);
    setGroup(0);
    setSearch('');
  };

  const [products, setProducts] = useState(products1);

  useEffect(() => {
    const prods =
      products1?.filter(
        v => Number(v.pr_group) === Number(group) || Number(group) === 0,
      ) || [];

    if (search && !isNaN(parseFloat(search)) && !cart) {
      setProducts(products1?.filter(o => o.value.pr_code === search));
    } else if (search.length >= 3 && !cart) {
      const fuse = new Fuse(prods, {
        includeScore: true,
        useExtendedSearch: true,
        keys: ['pr_name'],
      });
      setProducts(fuse.search(search).map(v => v.item));
    } else if (!search) {
      setProducts(
        prods?.filter(
          v =>
            (quantities?.hasOwnProperty(v.pr_id.toString()) && cart) || !cart,
        ),
      );
    }
  }, [search, data, cart, group]);

  const methods = useForm<any>({
    defaultValues: {
      po_id: 0,
      po_company: cid,
      po_date: moment(gdata.today).toDate(),
      po_no: '',
      po_supp: 0,
      po_name: '',
      po_address: '',
      po_state: gdata.defstate,
      po_country: gdata.defcountry,
      po_taxno: '',
      po_amt: '',
      po_remarks: '',
      po_flag: '1',
      po_uid: gdata.user,
      po_cdt: moment().toDate(),
      po_muid: gdata.user,
      po_mdt: moment().toDate(),
      po_details: [],
    },
    resolver: yupResolver(validationSchema),
  });

  const [insertPurchaseorder] = useInsertPurchaseorderMutation();
  const [updatePurchaseorder] = useUpdatePurchaseorderMutation();

  const onSubmit: SubmitHandler<st_epurchaseorder> = async values => {
    if (isSaving) return;

    try {
      const itms = Object.entries(quantities)
        .filter(([, product]) => product.quantity > 0)
        .map(([id, product], i) => ({
          pd_id: 0,
          pd_srid: i + 1,
          pd_prod: Number(id),
          pd_descr: product.descr,
          pd_qty: product.quantity,
          pd_rate: product.rate,
          pd_uom: 1,
          pd_discper: 0,
          pd_discamt: 0,
          pd_tax1: 0,
          pd_tax1per: 0,
          pd_tax1amt: 0,
          pd_tax2: 0,
          pd_tax2per: 0,
          pd_tax2amt: 0,
          pd_tax3: 0,
          pd_tax3per: 0,
          pd_tax3amt: 0,
          pd_amount: product.quantity * product.rate,
        }));

      values.po_details = itms;
      values.po_date = new Date();

      if (!values.po_details.length) return;

      setIsSaving(true);

      if (Number(values.po_id) !== 0) {
        await updatePurchaseorder(values).unwrap();
        ShowToast('Data Updated Successfully');
      } else {
        await insertPurchaseorder(values).unwrap();
        ShowToast('Data Saved Successfully');
      }

      methods.reset();
      setIsSaving(false);
      navigation.goBack();
    } catch (e: any) {
      ShowToast(e?.data?.message || e?.message || 'Failed to save purchase order', 'error');
      setIsSaving(false);
    }
  };

  const [billfooter, setBillfooter] = useState({
    stotqty: '0.00',
    stotamt: '0.00',
  });

  const CalcTot = () => {
    const totQty = Object.values(quantities).reduce(
      (sum, {quantity}) => sum + Number(quantity),
      0,
    );
    const totAmt = Object.values(quantities).reduce(
      (sum, {quantity, rate}) => sum + Number(rate) * Number(quantity),
      0,
    );

    methods.setValue('po_amt', totAmt);
    setBillfooter({
      stotqty: (totQty ?? 0).toFixed(2),
      stotamt: (totAmt ?? 0).toFixed(2),
    });
  };

  useEffect(() => {
    CalcTot();
  }, [quantities]);

  const updateItemField = (field: string, text: string, itemId: Number) => {
    setQuantities(prevQuantities => ({
      ...prevQuantities,
      [itemId.toString()]: {
        ...prevQuantities[itemId.toString()],
        [field]: text,
        descr: products?.find(v => v.pr_id === itemId)?.pr_name || '',
      },
    }));
  };

  const renderItem = (item: any) =>
    item ? (
      <View style={styles.conLstItem} key={item.pr_id}>
        <View style={styles.conLstData}>
          {group == 0 && (
            <Row>
              <Col>
                <Text style={styles.descr}>{item?.pr_grname}</Text>
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              {item?.pr_nameed && quantities[item.pr_id]?.quantity > 0 ? (
                <FormProvider {...methods}>
                  <TextInput
                    name={`descr.${item.pr_id}`}
                    label=""
                    placeholder={tp("Product Name")}
                    onChangeText={txt =>
                      updateItemField('descr', txt, item.pr_id)
                    }
                  />
                </FormProvider>
              ) : (
                <Text style={styles.heading}>{item?.pr_name}</Text>
              )}
            </Col>
          </Row>
          <Row style={styles.rowSec}>
            <Col>
              {Number(item?.pr_srate) === 0 ? (
                <FormProvider {...methods}>
                  <TextInput
                    name={`rate.${item.pr_id}`}
                    label=""
                    placeholder={tp("Rate")}
                    onChangeText={txt =>
                      updateItemField('rate', txt, item.pr_id)
                    }
                    keyboardType="numeric"
                  />
                </FormProvider>
              ) : (
                <Text style={styles.rate}>{'Rs. ' + item?.pr_srate}</Text>
              )}
            </Col>
            <Col style={styles.iconCol}>
              <TouchableOpacity
                onPress={() => handleCart(item, -1)}
                style={{
                  backgroundColor: '#FF6B6B',
                  padding: 1,
                  borderRadius: 50,
                  shadowColor: '#000',
                  shadowOffset: {width: 0, height: 4},
                  shadowOpacity: 0.3,
                  shadowRadius: 4,
                  elevation: 6,
                }}>
                <Icon
                  name="minus-circle"
                  size={42}
                  color="#FFF"
                  style={{alignSelf: 'center'}}
                />
              </TouchableOpacity>
            </Col>
            <Col>
              <Text style={styles.qty}>
                <FormProvider {...methods}>
                  <TextInput
                    name={`quantity.${item.pr_id}`}
                    label=""
                    placeholder={tp("Qty")}
                    value={quantities[item.pr_id]?.quantity.toString()}
                    onChangeText={txt =>
                      updateItemField('quantity', txt, item.pr_id)
                    }
                    keyboardType="numeric"
                  />
                </FormProvider>
              </Text>
            </Col>
            <Col style={styles.iconCol}>
              <TouchableOpacity
                onPress={() => handleCart(item, 1)}
                style={{
                  backgroundColor: '#28A745',
                  padding: 1,
                  borderRadius: 50,
                  shadowColor: '#000',
                  shadowOffset: {width: 0, height: 4},
                  shadowOpacity: 0.3,
                  shadowRadius: 4,
                  elevation: 6,
                }}>
                <Icon
                  name="plus-circle"
                  size={42}
                  color="#FFF"
                  style={{alignSelf: 'center'}}
                />
              </TouchableOpacity>
            </Col>
            <Col>
              <Text style={styles.amt}>
                {'Rs.' +
                  (Number(item.pr_srate) > 0
                    ? Number(item.pr_srate)
                    : quantities[item.pr_id]?.rate) *
                    (quantities[item.pr_id]?.quantity || 0)}
              </Text>
            </Col>
          </Row>
        </View>
      </View>
    ) : (
      <View />
    );

  return (
    <View style={styles.app}>
      {/* Modern Header */}
      <View style={styles.modernHeaderContainer}>
        <Text style={styles.modernHeaderTitle}><T>Purchase Order</T></Text>
      </View>

      <FormProvider {...methods}>
        {showHead && (
            <>
              <Row>
                <Col>
                  <BTComboBox
                    name="po_supp"
                    label="Supplier"
                    data={supps}
                    placeholder={tp("Supplier")}
                    onValChange={(_v: any) => {
                      methods.setValue(
                        'po_name',
                        supps?.find(
                          (v: any) => v.id === methods.getValues('po_supp'),
                        )?.label || 'Nill',
                      );
                      methods.setValue(
                        'po_address',
                        supps?.find(
                          (v: any) => v.id === methods.getValues('po_supp'),
                        )?.values.sp_address || 'Nill',
                      );
                      methods.setValue(
                        'po_state',
                        supps?.find(
                          (v: any) => v.id === methods.getValues('po_supp'),
                        )?.values.sp_state || 0,
                      );
                      methods.setValue(
                        'po_country',
                        supps?.find(
                          (v: any) => v.id === methods.getValues('po_supp'),
                        )?.values.sp_country || 0,
                      );
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInput
                    name="po_remarks"
                    label="Remarks"
                    placeholder={tp("Remarks")}
                  />
                </Col>
              </Row>
            </>
          )}
          <Row>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title="Save"
                  onPress={methods.handleSubmit(onSubmit, _errors => {
                    // Handle form errors
                  })}
                  onLongPress={() => {}}
                  color="#146C94"
                  disabled={isSaving}
                />
              </View>
            </Col>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title="Clear"
                  onPress={() => {
                    methods.reset();
                    setQuantities({});
                  }}
                  onLongPress={() => {}}
                  color="#146C94"
                  disabled={isSaving}
                />
              </View>
            </Col>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title="View"
                  onPress={handleCartClick}
                  onLongPress={() => {}}
                  color="#146C94"
                  disabled={isSaving}
                />
              </View>
            </Col>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title={`${
                    showHead
                      ? 'hide'
                      : supps
                          ?.find(
                            (v: any) => v.id == methods.getValues('po_supp'),
                          )
                          ?.label?.slice(0, 4) || 'Nill'
                  }`}
                  onLongPress={() => {}}
                  color="#146C94"
                  onPress={() => setShowHead(!showHead)}
                  disabled={isSaving}
                />
              </View>
            </Col>
          </Row>
          {cart && (
            <View style={{padding: 10}}>
              <Row>
                <Col>
                  <Text style={styles.heading}><T>Name</T></Text>
                </Col>
                <Col>
                  <Text>{methods.getValues('po_name')}</Text>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Text style={styles.heading}><T>Address</T></Text>
                </Col>
                <Col>
                  <Text>{methods.getValues('po_address')}</Text>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Text style={styles.heading}><T>Total Quantity</T></Text>
                </Col>
                <Col>
                  <Text>{billfooter.stotqty}</Text>
                </Col>
                <Col>
                  <Text style={[styles.amt, styles.heading]}>
                    {billfooter.stotamt}
                  </Text>
                </Col>
              </Row>
            </View>
          )}
          {!cart && (
            <Row>
              <Col>
                <BTComboBox
                  name="group"
                  label="Group"
                  data={groups}
                  placeholder={tp("Select Group")}
                  onValChange={(v: any) => setGroup(v)}
                />
              </Col>
            </Row>
          )}
        </FormProvider>
      {!cart && (
        <Row>
          <Col>
            <TextInput1
              style={styles.text}
              onChangeText={setSearch}
              value={search}
              placeholder={tp("Search")}
            />
          </Col>
        </Row>
      )}
      <View style={{flex: 1}}>
        <FlatList
          ItemSeparatorComponent={renderSeparator}
          data={products}
          renderItem={({item}) => renderItem(item)}
          onEndReachedThreshold={0.1}
          contentContainerStyle={{paddingBottom: 80}}
          keyboardShouldPersistTaps="handled"
        />
      </View>
    </View>
  );
};

export default STPurchaseOrder;

